import { View } from "react-native";
import { useSafeArea } from "src/swsh-native";

const GatheringHomeHeaderSpacer = () => {
	const safeArea = useSafeArea();
	return (
		<View
			style={{
				width: "100%",
				height: 80 + safeArea.top,
			}}
		/>
	);
};
export default GatheringHomeHeaderSpacer;
